"use client";

import { createContext, useContext } from "react";

const CspNonceContext = createContext<string | undefined>(undefined);

interface CspNonceProviderProps {
  nonce?: string;
  children: React.ReactNode;
}

export function CspNonceProvider({ nonce, children }: CspNonceProviderProps) {
  return (
    <CspNonceContext.Provider value={nonce}>
      {children}
    </CspNonceContext.Provider>
  );
}

export function useCspNonce() {
  return useContext(CspNonceContext);
}
